import FormItemOrg from './OrgList.vue'
import FormItemRole from './RoleList.vue'
import FormItemPosition from './Position.vue'

export default {
  FormItemOrg,
  FormItemRole,
  FormItemPosition
}
